import './SpinLoading.scss';

import { Spin } from 'antd';

interface SpinLoadingProps {
  className?: string;
}

const SpinLoading = (props: SpinLoadingProps) => {
  const { className } = props;

  return (
    <div className={`SpinLoading ${className ? className : ''}`}>
      <Spin className="SpinLoadingIcon" size="large" />
    </div>
  );
};

export default SpinLoading;
